module.exports = __webpack_public_path__ + "img/small.184c7c22.jpg";